window.map;
var sezione;
var map;
var arrayMar = {};
var infoWindow;
var markers = [];
var autocomplete;
var v1,v2;
var busca_agenzia_scroll = false
var isMobile = false;
// device detection
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
    isMobile = true;

function onlyNos(e, t) {
    try {
        if (window.event) {
            var charCode = window.event.keyCode;
        } else if (e) {
            var charCode = e.which;
        } else {
            return true;
        }

        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    } catch (err) {
        alert(err.Description);
    }
}

function getAgenzieilTuoMutuo(el) {
    var lat = el.attr("data-lat");
    var lng = el.attr("data-lng");
    var address = $("#indirizzoIltuoMutuo").val();
    var dati = "lat=" + lat + "&lng=" + lng + "&tipo=mappa&address=" + address;
    $.ajax({
        url: '/ajax/get-agenzie-iltuomutuo',
        type: 'post',
        data: dati,
    })
    .done(function(data) {
        $("#containerJSagenzie").html(data);
     });
}

function getLatLngIlTuoMutuo() {
    if ($("#indirizzoIltuoMutuo").hasClass('error')) {
        $("#indirizzoIltuoMutuo").removeClass('error');
    }
    var place = autocomplete.getPlace().formatted_address;
    $("#indirizzoIltuoMutuo").val(place);
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({'address': place}, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            Mylat = results[0].geometry.location;
            v1 = Mylat.lat();
            v2 = Mylat.lng();
            $("#trovaAgenzia").attr({
                'data-lat': v1,
                'data-lng': v2
            });
        }
    });
}

function findElementPosition(element) {
    var curtop = 0;
    if (element.offsetParent) {
        do {
            curtop += element.offsetTop;
        } while (element = element.offsetParent);
    return [curtop];
    }
}

function initMap(map, indirizzo, sezione='mappa', sProv = '', provenienza='', indiceAgenzia = 0, limitAgenzia = 6) {
    if ($("#mappaload").length > 0) {
        var geocoder = new google.maps.Geocoder();
        var bounds = new google.maps.LatLngBounds();

        geocoder.geocode({'address': indirizzo}, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var Mylat;

                // if (indirizzo.indexOf(".") > 0)
                // {
                //     var values = indirizzo.split(",");
                //     v1 = values[0];
                //     v2 = values[1];
                //     Mylat = new google.maps.LatLng(parseFloat(v1), parseFloat(v2));
                // }
                // else
                // {
                    Mylat = results[0].geometry.location;
                    v1 = Mylat.lat();
                    v2 = Mylat.lng();
                // }

                if ($('.gm-style div:first').find(".gmnoprint").length <= 0) {
                    var pezzoDaSpostare = $(".gmnoprint").find(".gm-style-mtc").parent();
                    var attribute = pezzoDaSpostare.attr("style") + "z-index: 3 !important;";
                    pezzoDaSpostare.appendTo('.gm-style div:first');
                    $('.gm-style div:first').find(".gmnoprint").attr("style",attribute);
                    var buttonSpostare = $("button[title='Attiva/disattiva vista schermo intero']");
                    setTimeout(function() {
                        var attributeButton = $("button[title='Attiva/disattiva vista schermo intero']").attr("style") + "z-index: 3 !important;";
                        $("button[title='Attiva/disattiva vista schermo intero']").appendTo(".gm-style div:first");
                        $("button[title='Attiva/disattiva vista schermo intero']").attr("style",attributeButton);
                    }, 300)
                }

                if (provenienza =='cercaAgenziaMutuo') {
                    $("#laMiaPosizione").val($("#indirizzo").val());
                    $("#latMiaPosizione").val(v1);
                    $("#lngMiaPosizione").val(v2);
                }

                if (map == undefined) {
                    map = new google.maps.Map(document.getElementById("mappaload"), {
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        streetViewControlOptions: {
                            position: google.maps.ControlPosition.RIGHT_BOTTOM,
                        },
                        zoomControl: true,
                        zoomControlOptions: {
                            style: google.maps.ZoomControlStyle.LARGE,
                            position: google.maps.ControlPosition.RIGHT_BOTTOM,
                        },
                        //zoom: 12,
                        disableDoubleClickZoom: false
                    });
                }

                map.setCenter(Mylat);

                if (sezione == 'mappa') {
                    var marIconTuseiQui = new google.maps.MarkerImage(
                        '/img/trovagenzia/markerTuSeiQui.png',
                        null, /* size is determined at runtime */
                        null, /* origin is 0,0 */
                        null, /* anchor is bottom center of the scaled image */
                        new google.maps.Size(30, 35)
                    );

                    var markerTuseiQui = new google.maps.Marker({
                        position: Mylat,
                        map: map,
                        description: "Tu sei qui!",
                        icon: marIconTuseiQui,
                        animation: google.maps.Animation.DROP
                    });
                }

                var AgenziaList;
                $.ajax({
                    url: '/getagenziemappa',
                    type: 'POST',
                    data: {
                        lat: v1,
                        lng: v2,
                        tipo: sezione,
                        siglaProv: sProv
                    },
                    success: function(data) {
                        $("#nTotAgenzie").html(data.length);
                        if (busca_agenzia_scroll == 'scroll') {
                            var screen_width = window.innerWidth || window.clientWidth;
                            let offset_scroll = findElementPosition(document.getElementById("containerAgenzieMappa"))

                            if (screen_width < 400 && offset_scroll) {
                                window.scroll(0, offset_scroll - 90);
                            }
                        } else {
                            busca_agenzia_scroll = 'scroll'
                        }

                        markers = [];
                        if (indiceAgenzia == 0) {
                            $("#Agenzie-list .list").html("");
                            $("#Agenzie-list .pagination").html("");
                            // $(".fuzzy-search").show();
                        }

                        if (data.length > 0) {
                            var sDistanza = "";
                            if (sezione =='mappa') {
                                sDistanza = '<span class="km"><span class="distance_in_km"></span> km</span>';
                            }

                            sessionStorage['sezioneMappaAg'] = sezione;
                            sessionStorage['sezioneProv'] = sProv;
                            var sSitoWeb = '<a class="P_URLMINISITO P_URLMINISITO_TITLE" href="P_URLMINISITO" title="P_URLMINISITO_TITLE" target="_blank"><font class="hidable">&nbsp;-&nbsp;</font>Ir a la web de agencia</a>';

                            if (provenienza =='cercaAgenziaMutuo') {
                                var sItem = '<li ><label><input type="radio" name="idAgenzia"><span class="S_RAGSOC"></span>'
                                    + '<br><span class="S_INDIRIZZO"></span>, <span class="S_CAP"></span> <span class="S_COMUNE"></span> (<span class="S_SIGLAPRV"></span>) ' + sDistanza + '</label></li>';
                                //listato
                                var options = {
                                    valueNames: [
                                        'S_ZONA', 'S_RAGSOC', 'S_INDIRIZZO', 'S_CAP', 'S_COMUNE', 'S_SIGLAPRV', 'distance_in_km', 'AGENZIA',
                                        {data: ['Agenzia']},
                                    ],
                                    page: 6,
                                    pagination: true,
                                    item: sItem
                                };
                            } else {
                                var sItem = '<li><h3 class="S_RAGSOC"></h3>'
                                    + '<p class="address_wrapper"><span class="S_INDIRIZZO"></span>, <span class="S_CAP"></span>  (<span class="S_SIGLAPRV"></span>)  ' + sDistanza + ' </p><p class="telephone_wrapper">Teléfono: <span class="S_TELEFONO"></span>' + sSitoWeb + '</p> </li>';
                                //listato
                                var options = {
                                    valueNames: [
                                        'S_ZONA', 'S_RAGSOC', 'S_INDIRIZZO', 'S_CAP', 'S_COMUNE', 'S_SIGLAPRV', 'distance_in_km', 'AGENZIA',
                                        'S_TELEFONO', {attr: 'href', name: 'P_URLMINISITO'},
                                        {attr: 'title', name: 'P_URLMINISITO_TITLE'},
                                        {data: ['HOMEPAGE_ATTIVA']},
                                        {data: ['Agenzia']},
                                    ],
                                    page: 6,
                                    pagination: true,
                                    item: sItem
                                };
                            }

                            if (AgenziaList != undefined && indiceAgenzia == 0) {
                                AgenziaList.clear();
                            }

                            if (indiceAgenzia == 0) {
                                AgenziaList = new List('Agenzie-list', options, data);
                            }
                            //cancello tutti i link in lista che hanno link nullo

                            $("#Agenzie-list a.P_URLMINISITO.P_URLMINISITO_TITLE[href=null]").remove();

                            //marker
                            for (i = indiceAgenzia; i < limitAgenzia && i < data.length; i++) {
                                var marIcon = new google.maps.MarkerImage(
                                    '/img/trovagenzia/marker.png',
                                    null, /* size is determined at runtime */
                                    null, /* origin is 0,0 */
                                    null, /* anchor is bottom center of the scaled image */
                                    new google.maps.Size(30, 35)
                                );

                                var marIcon2 = new google.maps.MarkerImage(
                                    '/img/trovagenzia/markerOver.png',
                                    null, /* size is determined at runtime */
                                    null, /* origin is 0,0 */
                                    null, /* anchor is bottom center of the scaled image */
                                    new google.maps.Size(30, 35)
                                );

                                var marIconEpi = new google.maps.MarkerImage(
                                    '/img/trovagenzia/markerEpica.png',
                                    null, /* size is determined at runtime */
                                    null, /* origin is 0,0 */
                                    null, /* anchor is bottom center of the scaled image */
                                    new google.maps.Size(30, 35)
                                );

                                var marIconEpiOver = new google.maps.MarkerImage(
                                    '/img/trovagenzia/markerEpicaOver.png',
                                    null, /* size is determined at runtime */
                                    null, /* origin is 0,0 */
                                    null, /* anchor is bottom center of the scaled image */
                                    new google.maps.Size(30, 35)
                                );

                                var sFormContatti = "<div class='containerFormInfoAgenzia' id='containerForm" + data[i]['Agenzia'] + "'>"
                                    + "<form id='formRichiediAppAgenzia' class='form-inline'>"
                                    + "<input type='hidden' id='agenzia' name='agenzia' value='" + data[i]['Agenzia'] + "'/>"
                                    + "<input type='hidden' id='laMiaPosizione' name='laMiaPosizione' value='" + $("#indirizzo").val() + "'/>"
                                    + "<input type='hidden' id='latMiaPosizione' name='latMiaPosizione' value='" + v1 + "'/>"
                                    + "<input type='hidden' id='lngMiaPosizione' name='lngMiaPosizione' value='" + v2 + "'/>"
                                    + "<div class='form-group'>"
                                    + "<label class='sr-only' for='nome'>Nombre*</label>"
                                    + "<input class='form-control' type='text' id='nome' name='nome' value='' placeholder='Nombre*'>"
                                    + "</div>"
                                    + "<div class='form-group'>"
                                    + "<label class='sr-only' for='cognome'>Apellido*</label>"
                                    + " <input class='form-control' type='text' id='cognome' name='cognome' value='' placeholder='Apellido*'>"
                                    + "</div>"
                                    + "<div class='form-group'>"
                                    + "<label class='sr-only' for='email'>Email*</label>"
                                    + " <input class='form-control' type='text' id='email' name='email' value='' placeholder='Email*'>"
                                    + "</div>"
                                    + "<div class='form-group'>"
                                    + "<label class='sr-only' for='telefono'>Teléfono*</label>"
                                    + " <input class='form-control' type='text' id='telefono' name='telefono' value='' placeholder='Teléfono*'>"
                                    + "</div>"
                                    + "<p class='privacy'>He leído y acepto la política de privacidad [<a href='/politicadeprivacidad' target='_blank'>leer más</a>]</p>"
                                    + "<button type='button' id='inviaAppAgenzia" + data[i]['Agenzia'] + "' class='btn btn-invia inviaAppAgenzia'>Envía</button>"
                                    + "<button type='button' class='btn btn-default' id='annullaFormContatta'>Cancela</button>"
                                    /*+ "<p>{!! trans('kironlan.iltuomutuosenzapre.privacy') !!}</p>"
                                    + "<div class='checkbox' id='divPrivacyMK'>"
                                        + "<input id='labelfc_privacy' name='marketing' value='16' class='styled' type='checkbox'>"
                                        + "<label for='labelfc_privacy' class='privacy'>"
                                        + "<a style='cursor:pointer' data-toggle='tooltip' title=' data-original-title'{!! trans('kironlan.iltuomutuosenzapre.marketingTooltip') !!'>"
                                        + "{!! trans('kironlan.iltuomutuosenzapre.marketing') !!}"
                                        + "</a>"
                                        + "</label>"
                                    + "</div>"*/
                                    + "</form>"
                                    + "</div><div class='infoFormContAg'></div>";

                                var sSitoWebDesc = (data[i]['HOMEPAGE_ATTIVA'] == '1' && data[i]['P_URLMINISITO'] !== null) ? '<p><strong>Homepage:</strong>&nbsp;<a href="' + data[i]['P_URLMINISITO'] + '">' + data[i]['P_URLMINISITO'] + '</a><p/>' : "";

                                if (provenienza == 'cercaAgenziaMutuo') {
                                    var sDescr = "<div id='infoWindowCont'><h3 class='titoloRgSoc'>"
                                        + data[i]['S_RAGSOC'] + "</h3><p class='indirizzoAgenzia'> <strong>Dirección:</strong> "
                                        + data[i]['S_INDIRIZZO'] + ", " + data[i]['S_CAP'] + ", " + data[i]['S_COMUNE']
                                        + " (" + data[i]['S_SIGLAPRV'] + ")</p><p><strong>Email:</strong> "
                                        + data[i]['EMAIL'] + "</p><p>"
                                        + (data[i]['S_TELEFONO'] ? "<strong>Teléfono:</strong> " + data[i]['S_TELEFONO'] : '') + "</p>" + sSitoWebDesc + "</div>";
                                } else {
                                    var sDescr = "<div id='infoWindowCont'><h3 class='titoloRgSoc'>"
                                        + data[i]['S_RAGSOC'] + "</h3><p class='indirizzoAgenzia'> <strong>Dirección:</strong> "
                                        + data[i]['S_INDIRIZZO'] + ", " + data[i]['S_CAP'] + ", " + data[i]['S_COMUNE']
                                        + " (" + data[i]['S_SIGLAPRV'] + ")</p><p><strong>Email:</strong> "
                                        + data[i]['EMAIL'] + "</p>"
                                        + (data[i]['S_TELEFONO'] ? "<p><strong>Teléfono:</strong> " + data[i]['S_TELEFONO'] + "</p>" : '')
                                        + sSitoWebDesc + "</div><div class='ContainerRichiediApp'><button class='btn btn-info buttonRichiediApp' type='button' data-id='"
                                        + data[i]['Agenzia'] + "' data-lat='" + data[i]['S_LATITUDINE'] + "' data-lng='" + data[i]['S_LONGITUDINE'] + "' data-rgs='"
                                        + data[i]['S_RAGSOC'] + "'>Búscame una hipoteca</button>" + sFormContatti + "</div>";
                                }

                                if (data[i]['RETE'] == 'epi') {
                                    var marker = new google.maps.Marker({
                                        id: data[i]['Agenzia'],
                                        position: new google.maps.LatLng(data[i]['S_LATITUDINE'], data[i]['S_LONGITUDINE']),
                                        map: map,
                                        description: sDescr,
                                        icon: marIconEpi,
                                        rete: data[i]['RETE'],
                                        ragioneSoc: data[i]['S_RAGSOC'],
                                        url: '/richiedi-appuntamento/?id=' + data[i]['Agenzia'],
                                        animation: google.maps.Animation.DROP
                                    });
                                } else {
                                    var marker = new google.maps.Marker({
                                        id: data[i]['Agenzia'],
                                        position: new google.maps.LatLng(data[i]['S_LATITUDINE'], data[i]['S_LONGITUDINE']),
                                        map: map,
                                        description: sDescr,
                                        icon: marIcon,
                                        rete: data[i]['RETE'],
                                        ragioneSoc: data[i]['S_RAGSOC'],
                                        url: '/richiedi-appuntamento/?id=' + data[i]['Agenzia'],
                                        animation: google.maps.Animation.DROP
                                    });
                                }

                                if (sezione == 'linkProvince') {
                                    bounds.extend(marker.position);
                                } else if (i == indiceAgenzia) {
                                    // solo prima agenzia
                                    bounds.extend(Mylat);
                                    bounds.extend(marker.position);
                                }

                                markers[data[i]['Agenzia']] = marker;

                                var currentMarker = null;
                                var selezionaMarkerAgenzia = function (marker, map, marIcon, marIcon2, marIconEpi, marIconEpiOver) {
                                    google.maps.event.addListener(marker, 'click', function () {
                                        // remove the bounce from the "old" marker
                                        if (currentMarker) {
                                            infoWindow.close(map, marker);
                                            currentMarker.setAnimation(null);
                                            if (currentMarker.rete=='epi') {
                                                currentMarker.setIcon(marIconEpi);
                                            } else {
                                                currentMarker.setIcon(marIcon);
                                            }

                                            arrayMar[currentMarker.id] = undefined;
                                        }

                                        if (this.id) {
                                            arrayMar[this.id] = 1;
                                        }

                                        if (provenienza =='cercaAgenziaMutuo') {
                                            $("#agenzia").val(this.id);
                                            $("#Agenzie-list").find("li[data-agenzia=" + this.id + "] input[type=radio]").prop("checked", true);
                                        }

                                        $("#Agenzie-list li").removeAttr('style');
                                        $("#Agenzie-list li").removeAttr('data-click');
                                        $("#Agenzie-list").find("li[data-agenzia=" + this.id + "]").attr("data-click", "1");

                                        //serve per cambiare pagina finche non trova agenzia corretta
                                        if ($("#Agenzie-list").find("li[data-agenzia=" + this.id + "]").length == 0) {
                                            for (var x =1; x <= $(".pagination li").length; x++) {
                                                if ($("#Agenzie-list").find("li[data-agenzia=" + this.id + "]").length == 0) {
                                                    $(".pagination li:nth-child(" + x + ")").trigger('click');
                                                }
                                            }
                                        }

                                        $("#Agenzie-list").find("li[data-agenzia=" + this.id + "]").css("background", "#ececec");

                                        var markerLat = marker.getPosition().lat();
                                        var markerLng = marker.getPosition().lng();

                                        infoWindow = new google.maps.InfoWindow();
                                        var idSessione = this.id;
                                        infoWindow.setContent(this.description);

                                        if ($('.gm-style div:first').find(".gmnoprint").length <= 0) {
                                            var pezzoDaSpostare = $(".gmnoprint").find(".gm-style-mtc").parent();
                                            var attribute= pezzoDaSpostare.attr("style") + "z-index: 3 !important;";
                                            pezzoDaSpostare.remove();
                                            $(pezzoDaSpostare).appendTo('.gm-style div:first');
                                            $('.gm-style div:first').find(".gmnoprint").attr("style", attribute);
                                        }

                                        infoWindow.open(map, marker);
                                        markerLng = parseFloat(markerLng);
                                        map.setZoom(12);

                                        if (isMobile || $(window).width() < 990) {
                                            markerLat = parseFloat(markerLat) + 0.06;
                                        } else {
                                            markerLat = parseFloat(markerLat) + 0.05;
                                        }

                                        setTimeout(function() {
                                            map.panTo(new google.maps.LatLng(markerLat, markerLng));
                                        }, 300);

                                        currentMarker = marker;

                                        marker.setAnimation(google.maps.Animation.BOUNCE);
                                        setTimeout(function () {
                                            marker.setAnimation(null);
                                        }, 1450);

                                        $.each($("#Agenzie-list .list li"), function () {
                                            if (markers[$(this).attr("data-agenzia")].rete == 'epi') {
                                                markers[$(this).attr("data-agenzia")].setIcon(marIconEpi);
                                            } else {
                                                markers[$(this).attr("data-agenzia")].setIcon(marIcon);
                                            }
                                        });

                                        if (this.rete == 'epi') {
                                            marker.setIcon(marIconEpiOver);
                                        } else {
                                            marker.setIcon(marIcon2);
                                        }
                                    });
                                }

                                selezionaMarkerAgenzia(marker, map, marIcon, marIcon2, marIconEpi, marIconEpiOver);

                                google.maps.event.addListener(marker, 'mouseover', function (marker, i) {
                                    $.each($("#Agenzie-list .list li"), function () {
                                        if (markers[$(this).attr("data-agenzia")].rete == 'epi') {
                                            markers[$(this).attr("data-agenzia")].setIcon(marIconEpi);
                                        } else {
                                             markers[$(this).attr("data-agenzia")].setIcon(marIcon);
                                        }
                                    });
                                    if ($("#Agenzie-list").find("li[data-agenzia=" + this.id + "]").attr("data-click") == undefined) {
                                        $("#Agenzie-list").find("li[data-agenzia=" + this.id + "]").attr("style", "background:#f3f3f3");
                                    }
                                    if (this.rete == 'epi') {
                                        this.setIcon(marIconEpiOver);
                                    } else {
                                        this.setIcon(marIcon2);
                                    }
                                });

                                google.maps.event.addListener(marker, 'mouseout', function (marker, i) {
                                    if (arrayMar[this.id] == undefined) {
                                        if (this.rete == 'epi') {
                                            this.setIcon(marIconEpi);
                                        } else {
                                            this.setIcon(marIcon);
                                        }
                                        this.setAnimation(null);
                                    }

                                    $.each($("#Agenzie-list .list li"), function () {
                                        if ($(this).attr("data-click") == 1) {
                                            if (markers[$(this).attr("data-agenzia")].rete == 'epi') {
                                                markers[$(this).attr("data-agenzia")].setIcon(marIconEpiOver);
                                            } else {
                                                markers[$(this).attr("data-agenzia")].setIcon(marIcon2);
                                            }
                                        } else if ($(this).attr("data-click") != 1) {
                                            $(this).removeAttr("style");
                                        }
                                    });
                                });
                            }

                            map.fitBounds(bounds);

                            if (sezione == 'linkProvince') {
                                if (map.getZoom() > 14) {
                                    map.setZoom(13);
                                }
                            }

                            $("#Agenzie-list li[data-homepage_attiva='0'] .P_URLMINISITO.P_URLMINISITO_TITLE").remove();
                        }

                        if ($('#containerMappa').length && $('#indirizzo').val() != '') {
                            $('html,body').animate({
                                scrollTop: ($('#containerMappa').offset().top - 50)
                            }, 600);
                        }

                        return false
                    }
                })
                .fail(function() {
                    console.log("error");
                });
            } else if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                if ($("#indirizzo").val() != '') {
                     indirizzo = $("#indirizzo").val();
                } else {
                     indirizzo = $("#mappaload").attr("data-lat") + ", " + $("#mappaload").attr("data-lng");
                }
                setTimeout(initMap(map, indirizzo, sezione), 600);
            } else {
                //alert("Geocode was not successful for the following reason: " + status);
            }
        });

        $("#caricalistato").on("mouseover", "#Agenzie-list .list li", function() {
            var idAgenzia = $(this).attr("data-agenzia");
            myMarkerOver(idAgenzia, markers);
        });

        $("#caricalistato").on("mouseout", "#Agenzie-list .list li", function() {
            var urlMarker = "/img/trovagenzia/marker.png";
            var urlMarkerOver = '/img/trovagenzia/markerOver.png';
            $.each($("#Agenzie-list .list li"), function () {
                if ($(this).attr("data-click") != 1) {
                    $(this).removeAttr("style");
                }
            });

            if ($("#Agenzie-list").find("li[data-agenzia=" + $(this).attr("data-agenzia") + "]").attr("data-click") != undefined) {
                $("#Agenzie-list").find("li[data-agenzia=" + $(this).attr("data-agenzia") + "]").attr("style", "background:#ececec");
            }

            var marIcon = new google.maps.MarkerImage(
                urlMarker,
                null, /* size is determined at runtime */
                null, /* origin is 0,0 */
                null, /* anchor is bottom center of the scaled image */
                new google.maps.Size(30, 35)
            );

            var marIcon2 = new google.maps.MarkerImage(
                urlMarkerOver,
                null, /* size is determined at runtime */
                null, /* origin is 0,0 */
                null, /* anchor is bottom center of the scaled image */
                new google.maps.Size(30, 35)
            );

            var marIconEpi = new google.maps.MarkerImage(
                '/img/trovagenzia/markerEpica.png',
                null, /* size is determined at runtime */
                null, /* origin is 0,0 */
                null, /* anchor is bottom center of the scaled image */
                new google.maps.Size(30, 35)
            );

            var marIconEpiOver = new google.maps.MarkerImage(
                '/img/trovagenzia/markerEpicaOver.png',
                null, /* size is determined at runtime */
                null, /* origin is 0,0 */
                null, /* anchor is bottom center of the scaled image */
                new google.maps.Size(30, 35)
            );

            $.each($("#Agenzie-list .list li"), function () {
                if ($(this).attr("style")) {
                    if (markers[$(this).attr("data-agenzia")].rete == 'epi') {
                        markers[$(this).attr("data-agenzia")].setIcon(marIconEpiOver);
                    } else {
                        markers[$(this).attr("data-agenzia")].setIcon(marIcon2);
                    }
                } else if (markers[$(this).attr("data-agenzia")] != undefined) {
                    if (markers[$(this).attr("data-agenzia")].rete == 'epi') {
                        markers[$(this).attr("data-agenzia")].setIcon(marIconEpi);
                    } else {
                        markers[$(this).attr("data-agenzia")].setIcon(marIcon);
                    }
                }
            });
        });
    }
}

function isEmpty(value) {
    return (value == undefined || value === false || value=== '' || value === ' ');
 }

function setAddress() {
    var place = autocomplete.getPlace().formatted_address;
    $("#indirizzo").val(place);
    clickButtonCercaAgenzia(map);
};

function changeSliderAnticipo($maxValue) {
    $maxValue = getNumber($maxValue);
    var $minValue = Math.ceil($maxValue / 100 * 20);
    var $value = getNumber($("#mutuo-Anticipo").val());

    if ($value < $minValue) {
        $value = $minValue;
    }
    else if ($value > $maxValue) {
        $value = $maxValue;
    }

    $("#slider-mutuo-anticipo").slider({
        range: "max",
        min: $minValue,
        max: $maxValue,
        value: $value,
        slide: function(event, ui) {
            $("#mutuo-Anticipo").val(formatNumber(ui.value));
        }
    });

    $("#mutuo-Anticipo").val(formatNumber($value));
}

function updateAffittoHref() {
    if ($('input#affitto-prezzo').length) {
        var prezzo_affitto = $("#affitto-prezzo").val();
        var latitude = $("#lat_affitto").val();
        var longitude = $("#long_affitto").val();
        href_richiesta_affitti = $("#richiesta-affitto").attr("href").split("?")[0];
        $('#richiesta-affitto').attr("href", href_richiesta_affitti + "?prezzo_affitto=" + prezzo_affitto + "&latitude=" + latitude + "&longitude=" + longitude);
    }
}

function updateVenditaHref() {
    if ($('input#immobile-Prezzo').length) {
        var mutuoImmobile = getNumber($("#immobile-Prezzo").val());
        var latitude = $("#lat_vendita").val();
        var longitude = $("#long_vendita").val();
        hrefRichiestaMutuo = $("#richiesta-mutuo").attr("href").split("?")[0];
        $('#richiesta-mutuo').attr("href", hrefRichiestaMutuo + "?importo_immobile=" + mutuoImmobile + "&latitude=" + latitude + "&longitude=" + longitude);
    }
}

function updateMutuoHref() {
    if ($('input#immobile-Prezzo').length) {
        var mutuoImmobile = getNumber($("#immobile-Prezzo").val());
        var latitude = $("#lat").val();
        var longitude = $("#long").val();

        hrefRichiestaMutuo = $("#richiesta-mutuo").attr("href").split("?")[0];
        $('#richiesta-mutuo').attr("href", hrefRichiestaMutuo + "?importo_immobile=" + mutuoImmobile + "&latitude=" + latitude + "&longitude=" + longitude);
    }
}

function setCoordinatesVendita() {
    var coords = autocomplete_vendita.getPlace();

    $("#indirizzo_vendita").val(coords.formatted_address);
    $("#lat_vendita").val(coords.geometry.location.lat());
    $("#long_vendita").val(coords.geometry.location.lng());

    updateVenditaHref()
}

function setCoordinatesAffitto() {
    var coords = autocomplete_affitto.getPlace();

    $("#indirizzo_affitto").val(coords.formatted_address);
    $("#lat_affitto").val(coords.geometry.location.lat());
    $("#long_affitto").val(coords.geometry.location.lng());

    updateAffittoHref()
}

window.formatNumber = function ($number) {
    if (typeof $number == 'string') {
        if ($number.indexOf(".") > 0) {
            $number = String($number).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
    }

    $number = parseInt($number) || "";
    return String($number).replace(/(.)(?=(\d{3}) + $)/g,'$1.');
}

$(document).ready(function($) {
    jQuery(function($) {
        $(window).scroll(function fix_element() {
            $('#sticky').css(
                $(window).scrollTop() > 500
                    ? {'position': 'fixed', 'bottom': '0px'}
                    : {'position': 'relative', 'top': 'auto'}
            );
            return fix_element;
        }());
      });

    $("#slider-affitto-prezzo")
        .slider({
            range: "max",
            min: 1,
            max: 3000,
            value: 1000,
            slide: function(event, ui) {
                $("#affitto-prezzo").val(formatNumber(ui.value));
                updateAffittoHref();
            }
        });

    $(document).on("keyup", "#affitto-prezzo", function() {
        updateAffittoHref();
        $(this).val(formatNumber($(this).val()));
    })

    var importo_immobile = $("#immobile-Prezzo").length
        ? $("#immobile-Prezzo").val().replace('.', '').replace('.', '')
        : 0;

    $("#slider-immobile-prezzo")
        .slider({
            range: "max",
            min: 1000,
            max: 2000000,
            value: importo_immobile,
            slide: function(event, ui) {
                $("#immobile-Prezzo").val(formatNumber(ui.value));
                changeSliderAnticipo(ui.value);
                updateVenditaHref();
            }
        });

    if ($(".inviaRichiestaMutuo").length > 0) {
        if (window.history && window.history.pushState) {
            window.history.pushState('forward', null, null);

            $(window).on('popstate', function() {
                location.href= "/buscar-hipoteca";
            });
        }
    }

    $(".inviaRichiestaMutuo").on('keypress', 'input[name=telefono]', function(evt) {
        return onlyNos(evt, this)
    });

    $(".inviaRichiestaMutuo").on('click', '#buttonInviap1', function() {
        if ($("#formhipotecap1").valid()) {
            $(this).prop("disabled", true);
            $("#formhipotecap1").submit();
        }
    });

    $(".stepRichiesta").on('click', '#buttonInviap1', function() {
        if ($("#formhipotecap1").valid()) {
            $(this).prop("disabled", true);
            $("#formhipotecap1").submit();
        }
    });

    $(".stepRichiesta").on('keypress', 'input[name=telefono]', function(evt) {
        return onlyNos(evt, this)
    });

    $(".hero-form").on('click', '#submit_btn', function() {
        $("#form-home-contatti").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error,element) {
                $('#' + element.attr('id') + '-error').show();
                return true;
            },
            rules: {
                nome: {
                    required: true,
                },
                cognome: {
                    required: true,
                },
                email: {
                    required: true,
                    verifyemail:true
                },
                telefono: {
                    required: true,
                    numberTelefono: true
                },
            }
        });

        if ($("#form-home-contatti").valid()) {
            $(this).prop("disabled", true);
            $("#form-home-contatti").submit();
        }
    });

    $(".hero-form").on('keyup', 'input', function() {
        $('#' + $(this).attr('id') + '-error').hide();
    });

    if ($('#form-affitto').length > 0) {
        $("#form-affitto").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error,element) {
                $('#' + element.attr('id') + '-error').show();
                return true;
            },
            rules: {
                affitto_prezzo: {
                    required: true,
                },
                indirizzo: {
                    required: true,
                },
            }
        });

        $(".form-affitto").on('click', '#richiesta-affitto', function(event) {
            event.preventDefault()

            if ($("#form-affitto").valid()) {
                $(this).prop("disabled", true);
                location.href = $(this).attr('href');
            }
        });

        $(".form-affitto").on('keyup', 'input', function() {
            $('#' + $(this).attr('id') + '-error').hide();
        });
    }

    if ($('#form-mutuo').length > 0) {
        $("#form-mutuo").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error,element) {
                $('#' + element.attr('id') + '-error').show();
                return true;
            },
            rules: {
                immobile_prezzo: {
                    required: true,
                },
                indirizzo: {
                    required: true,
                },
            }
        });

        $("#form-mutuo").on('click', '#richiesta-mutuo', function(event) {
            event.preventDefault()

            if ($("#form-mutuo").valid()) {
                $(this).prop("disabled", true);
                location.href = $(this).attr('href');
            }
        });

        $(".form-mutuo").on('keyup', 'input', function() {
            $('#' + $(this).attr('id') + '-error').hide();
        });
    }

    $(".stepRichiesta").on('click', '#inviaFormIltuoMutuo', function(event) {
        event.preventDefault();
        if ($("#formhipotecap2").valid()) {
            $(this).prop("disabled", true);
            $("#formhipotecap2").submit();
        }
    });

    if ($('#indirizzoIltuoMutuo').length > 0) {
        var input = document.getElementById('indirizzoIltuoMutuo');
        if (typeof google == "undefined") {
            $.getScript('https://maps.googleapis.com/maps/api/js?v=3.25&signed_in=false&libraries=drawing,places&language=' + nazione + '&key=' + keyApp, function() {
                if (autocomplete == undefined) {
                    autocomplete = new google.maps.places.Autocomplete(
                        /** @type {!HTMLInputElement} */(input),
                        {
                            types: ['geocode'],
                            componentRestrictions: {country: nazione}
                        }
                    );
                }

                autocomplete.addListener('place_changed', getLatLngIlTuoMutuo);
            });
        } else {
            if (autocomplete == undefined) {
                autocomplete = new google.maps.places.Autocomplete(
                    /** @type {!HTMLInputElement} */(input),
                    {
                        types: ['geocode'],
                        componentRestrictions: {country: nazione}
                    }
                );
            }
        }
    }

    $(".stepRichiesta ").on('click', '#trovaAgenzia', function(event) {
        event.preventDefault();
        if ($("#indirizzoIltuoMutuo").val() != '') {
            $("#indirizzoIltuoMutuo").removeClass('error');
            getAgenzieilTuoMutuo($(this));
        } else {
            $("#indirizzoIltuoMutuo").addClass('error');
        }
    });

    $('#formCercaAgenzia #indirizzo').keydown(function (e) {
        if (e.keyCode == 13 || e.keyCode == 9) {
            if ($(".pac-container .pac-item").hasClass('pac-item-selected') == true) {
                    var firstResult = $(".pac-container .pac-item.pac-item-selected .pac-item-query").text() + ", " + $(".pac-container .pac-item.pac-item-selected span:eq(3)").text();
            } else {
                if ($(".pac-container .pac-item:first span:eq(3)").text() == "") {
                    var firstResult = $(".pac-container .pac-item:first .pac-item-query").text();
                } else {
                    var firstResult = $(".pac-container .pac-item:first .pac-item-query").text() + ", " + $(".pac-container .pac-item:first span:eq(3)").text();
                }
            }
            $(e.target).blur();
            $("#indirizzo").val(firstResult);
            clickButtonCercaAgenzia(map);
        }
    });

    $("#global_header_home").on("change.bfhselectbox", ".bfh-countries", function() {
        var lang = $(this).val();
        var dati = "lang=" + lang + "&_token=" + $('meta[name=_token]').attr('content');
         $.ajax({
            type: "POST",
            url: '/customer/changeLang',
            data: dati,
            success: function(data) {
                if (data =='true') {
                    location.reload();
                }
            }
        })
    });

    var sideslider = $('[data-toggle=collapse-side]');
    var sel = sideslider.attr('data-target');
    var sel2 = sideslider.attr('data-target-2');

    sideslider.click(function(event) {
        $(sel).toggleClass('in');
        $(sel2).toggleClass('out');
    });

    $('#nav-icon4').click(function() {
        $(this).toggleClass('open');
    });

    $(document).ready(function() {
        $(".hamburger").click(function() {
            $(this).toggleClass("is-active");
        });
    });

    $("#global_content").on("click", "#invia_form_contatti", function() {
        if ($("#schedaContattoForm").valid()) {
            var dati = $("#schedaContattoForm").serialize();
             $.ajax({
                type: "POST",
                url: '/sendMail',
                data: dati,
                success: function(data) {
                    var aMes = data.split("|");
                    var check = aMes[0];
                    var sMes = aMes[1];
                    if (check=='ok') {
                        $("#schedaContattoForm")['0'].reset();
                    }
                    $("#infoForm").fadeIn("slow");
                    $("#infoForm").html(sMes);
                    setTimeout(function() {
                        $("#infoForm").fadeOut("slow");
                        $("#infoForm").html("");
                    }, 7000);
                }
            })
        }
    });

    var sCategoria;
    $("#global_content").on("click", "#aggiungiCategoria", function() {
        sCategoria = $(".bs-searchbox input").val();
        $("#confermaAggiungiCat").attr("data-categoria",sCategoria);
        $("#textCategoria").html(sCategoria);
        $("#modalAggiungiCategoria").modal("show");
    });

    $("#modalAggiungiCategoria").on("click", "#confermaAggiungiCat", function() {
        var dati = "categoria=" + sCategoria;
        $.ajax({
            type: "POST",
            url: "/aggiungiCategoria",
            data: dati,
            success: function(data) {
                if (data != "false") {
                    $("#categoria option:last-child").after("<option value='" + data.id + "' selected>" + data.nome + "</option>");
                    $("#categoria").selectpicker("refresh");
                    $("#modalAggiungiCategoria").modal("hide");
                } else {
                    $("#modalAggiungiCategoria").modal("hide");
                    $("#categoria").after("<p class='errorText'>" + aLang.categoriaNonInserita + "<p>");
                    setTimeout(function() {
                        $(".errorText").remove();
                    }, 3000);
                }
            }
        })
    });

    $("#global_content").on("change", "#categoria", function() {
        var idCategoria = $("#categoria option:selected").val();
        var sCategoria = $("#categoria option:selected").text();
        var dati = "idCategoria=" + idCategoria;
        if (idCategoria != '') {
            $.ajax({
                type: "POST",
                url: '/getImgCategoria',
                data: dati,
                success: function(data) {
                    var x= 1;
                    var aUrlImg = "";
                    var aCaptionImg = "";
                    if (data.length) {
                        var aUrlImg = [];
                        var aCaptionImg = [];
                        $.each(data, function(index,value) {
                            aUrlImg.push("/img/gallery/" + idCategoria + "/" + value.url);
                            aCaptionImg.push({
                                caption: "<div id='containerTitoloPlan" + value.id + "' class='containerTitoloPlan'><input type='text' name='inputTitolo" + value.id + "' id='inputTitolo" + value.id + "' class='titoloPlanimetria' value='" + value.nome + "'/><button type='button' class='modificaTitoloPlanimetria' data-id='" + value.id + "'><i class='fa fa-thumbs-o-up' aria-hidden='true'></i></div>",
                                size: "",
                                url: "/elimina-immagine/" + value.id,
                                key: value.id
                            })
                            x = x + 1;
                         });
                    } else {
                        aUrlImg = '';
                        aCaptionImg = "";
                    }

                    $("#containerImgCat").show();
                    $("#immagini").fileinput("destroy");
                    $("#immagini").fileinput('refresh', {
                        uploadUrl: "/modifica-immagine",
                        uploadAsync: false,
                        showClose: false,
                        minFileCount: 1,
                        browseLabel: '',
                        removeLabel: '',
                        maxFileSize: 10000,
                        msgSizeTooLarge: 'File "{name}" (<b>{size} KB</b>) supera il limite massimo di dimensione consentita per l\'upload (<b>{maxSize} KB</b>).',
                        msgFilesTooLess: 'Devi caricare almeno <b>{n}</b> {files} per l\'upload.',
                        uploadLabel: 'Carica',
                        msgUploadThreshold: 'Caricamento...',
                        browseIcon: '<i class="glyphicon glyphicon-folder-open"></i>',
                        removeIcon: '<i class="glyphicon glyphicon-remove"></i>',
                        //maxFileCount: 5,
                        overwriteInitial: false,
                        previewId:x,
                        msgSelected: '{n} immagini selezionati',
                        msgZoomModalHeading: "Immagine Preview",
                        initialPreview: aUrlImg,
                        initialPreviewAsData: true, // defaults markup
                        initialPreviewFileType: 'image', // image is the default and can be overridden in config below
                        initialPreviewConfig: aCaptionImg,
                        showCaption:true,
                        purifyHtml: true,
                        uploadExtraData: {
                            idCategoria: idCategoria,
                            nameInput : "immagini",
                            sUrlAmbiente : sCategoria,
                            ordine: x,
                            _token: $("meta[name=_token]").attr("content")
                        },
                        deleteExtraData: function () {
                            var infoDelete = {
                                IDCategoria:idCategoria
                            }
                            return infoDelete;
                        }
                    }).on('filesorted', function(e, params) {
                        ordinaImmagine(params.stack, "immagini");
                    }).on('fileuploaded', function(e, params) {
                        console.log('File uploaded params', params);
                        //$('#Esterni .kv-preview-thumb').last().find(".kv-file-remove").attr("style", "display:none");
                    });

                    $('#immagini').on('filebatchuploadcomplete', function(event, files, extra) {
                        $('#containerImgCat .file-input').addClass('file-input-ajax-new');
                        $('#containerImgCat .kv-upload-progress').addClass('hide');
                    });
                }
            })
        } else {
            $('#containerImgCat').hide('');
        }
    });

    function ordinaImmagine(data, tabella) {
        var dati = "dati=" + JSON.stringify(data) + "&tabella=" + tabella;

        $.ajax({
            type: "POST",
            url: '/aggiorna-ordine-immagine',
            data: dati,
            cache: false,
            success: function (data) {
                $("#infoModal .modal-body").html(data);
                $("#infoModal").modal("show");
                setTimeout(function() {
                    $("#infoModal").modal("hide");
                }, 3000)
            }
        });
    }

    $("#global_content").on("click", ".modificaTitoloPlanimetria", function() {
        var IDImmagine = $(this).attr("data-id");
        var sTitolo = $("#inputTitolo" + IDImmagine).val();
        var dati = "IDImmagine=" + IDImmagine + "&titolo=" + sTitolo + "&tabella=immagini";
        $.ajax({
            type: "POST",
            url: '/aggiornanomeimg',
            data: dati,
            cache: false,
            success: function (data) {
                $("#infoModal .modal-body").html(data);
                $("#infoModal").modal("show");
                setTimeout(function() {
                    $("#infoModal").modal("hide");
                },3000)
            }
        });
    });

    $.ajaxSetup({
        headers: {'X-CSRF-Token' : $('meta[name=_token]').attr('content')}
    });

    if ($("#formCercaAgenziaHome").length > 0) {
        if (document.addEventListener) {
            document.getElementById('indirizzo').addEventListener("keyup", function () {
                var input = document.getElementById('indirizzo');
                if (autocomplete == undefined) {
                    autocomplete = new google.maps.places.Autocomplete(
                        /** @type {!HTMLInputElement} */(input),
                        {
                            types: ['geocode'],
                            componentRestrictions: {country: nazione}
                        }
                    );
                }

            });
        } else {
            document.getElementById('indirizzo').attachEvent("keyup", function () {
                var input = document.getElementById('indirizzo');
                if (autocomplete == undefined) {
                    autocomplete = new google.maps.places.Autocomplete(
                        /** @type {!HTMLInputElement} */(input),
                        {
                            types: ['geocode'],
                            componentRestrictions: {country: nazione}
                        }
                    );
                }
            });
        }
     }

    if ($("#containerAffitto").length > 0 || $("#containerMutuo").length > 0) {
        if ($('#indirizzo_vendita').length > 0) {
            input = document.getElementById('indirizzo_vendita')
            autocomplete_vendita = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(input),
                {
                    types: ['geocode'],
                    componentRestrictions: {country: nazione}
                }
            );

            if (document.addEventListener) {
                input.addEventListener("keyup", function () {
                    autocomplete_vendita.addListener('place_changed', setCoordinatesVendita);
                });
            }  else {
                input.attachEvent("keyup", function () {
                    autocomplete_vendita.addListener('place_changed', setCoordinatesVendita);
                });
            }
        }

        if ($('#indirizzo_affitto').length > 0) {
            input = document.getElementById('indirizzo_affitto')
            autocomplete_affitto = new google.maps.places.Autocomplete(
                /** @type {!HTMLInputElement} */(input),
                {
                    types: ['geocode'],
                    componentRestrictions: {country: nazione}
                }
            );

            if (document.addEventListener) {
                input.addEventListener("keyup", function () {
                    autocomplete_affitto.addListener('place_changed', setCoordinatesAffitto);
                });
            } else {
                input.attachEvent("keyup", function () {
                    autocomplete_affitto.addListener('place_changed', setCoordinatesAffitto);
                });
            }
        }
    }

    //cerca agenzia
    if ($('#cercaAgenzia').length > 0 || $('#sectionCercaAgenzia').length > 0) {
        if (map == undefined &&  $('#cercaAgenzia').length > 0) {
            if ($("#indirizzo").val() != '') {
                var indirizzo = $("#indirizzo").val();
            } else {
                var indirizzo = $("#mappaload").attr("data-lat") + ", " + $("#mappaload").attr("data-lng");
            }

            initMap(map, indirizzo);
        }

        var input = document.getElementById('indirizzo');

        if (typeof google == "undefined") {
            $.getScript('https://maps.googleapis.com/maps/api/js?v=3.25&signed_in=false&libraries=drawing,places&language=it&key=' + keyApp, function() {
                if (autocomplete == undefined) {
                    autocomplete = new google.maps.places.Autocomplete(
                        /** @type {!HTMLInputElement} */(input),
                        {
                            types: ['geocode'],
                            componentRestrictions: {country:  nazione}
                        }
                    );
                }
                autocomplete.addListener('place_changed', setAddress);
            });
        } else {
            if (autocomplete == undefined) {
                autocomplete = new google.maps.places.Autocomplete(
                    /** @type {!HTMLInputElement} */(input),
                    {
                        types: ['geocode'],
                        componentRestrictions: {country:  nazione}
                    }
                );
            }
        }

        if ($('#cercaAgenzia').length > 0) {
            autocomplete.addListener('place_changed', setAddress);
        }

        if (document.addEventListener) {
            if ($('#Agenzie-list').length > 0) {
                document.getElementById("Agenzie-list").addEventListener("click", function(e,map) {
                    if (e.target && $(e.target).attr('class') == 'page' && $(e.target).parent().attr('class') != 'disabled') {
                        var nPag = $(e.target).text();
                        if ($("#indirizzo").val() != '') {
                            var indirizzo = $("#indirizzo").val();
                        } else {
                            var indirizzo = $("#mappaload").attr("data-lat") + ", " + $("#mappaload").attr("data-lng");
                        }

                        var limitAgenzia = nPag * 6;
                        var indiceAgenzia = limitAgenzia - 6;
                        $('#containerAgenzieMappa .loader').show();

                        initMap(map, indirizzo, sessionStorage['sezioneMappaAg'], sessionStorage['sezioneProv'], '', indiceAgenzia, limitAgenzia);
                    }
                });
            }

            if ($('#cercaAgenzia').length > 0) {
                document.getElementById('cercaAgenzia').addEventListener("click", function () {
                    clickButtonCercaAgenzia(map);
                });
            }
        } else {
            if ($('#Agenzie-list').length > 0) {
                document.getElementById("Agenzie-list").attachEvent("click", function(e) {
                    if (e.target && $(e.target).attr('class') == 'page' && $(e.target).parent().attr('class') != 'disabled') {
                        var nPag = $(e.target).text();
                        if ($("#indirizzo").val() != '') {
                            var indirizzo = $("#indirizzo").val();
                        } else {
                            var indirizzo = $("#mappaload").attr("data-lat") + ", " + $("#mappaload").attr("data-lng");
                        }
                        var limitAgenzia = nPag*6;
                        var indiceAgenzia = limitAgenzia-6;

                        $('#containerAgenzieMappa .loader').show();

                        initMap(map, indirizzo, sessionStorage['sezioneMappaAg'], sessionStorage['sezioneProv'], '', indiceAgenzia, limitAgenzia);
                    }
                });
            }

            if ($('#cercaAgenzia').length > 0) {
                document.getElementById('cercaAgenzia').attachEvent("click", function () {
                     clickButtonCercaAgenzia(map);
                });
            }
        }
    }

    if ($('#cercaAgenziaMutuo').length > 0) {
        document.getElementById('indirizzo').addEventListener("keyup", function () {
            var input = document.getElementById('indirizzo');

            if (autocomplete == undefined) {
                    autocomplete = new google.maps.places.Autocomplete(
                    /** @type {!HTMLInputElement} */(input),
                    {
                        types: ['geocode'],
                        componentRestrictions: {country: nazione}
                    }
                );
            }
        });
    }

    $("#mappaload").on("click", ".buttonRichiediApp", function() {
        var id = $(this).attr("data-id");
        $(this).css("display", "none");
        $("#containerForm" + id).fadeIn("slow");
        $("#formRichiediAppAgenzia").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error, element) {
                return true;
            },
            rules: {
                nome: {
                    required: true,
                },
                cognome: {
                    required: true,
                },
                email: {
                    required: true,
                    verifyemail:true
                },
                telefono: {
                    required: true,
                    numberTelefono: true
                },
                privacy: {
                    required: true,
                    checkedPrivacy: true
                },
            }
        });
    });

    $("#mappaload").on("click", "#annullaFormContatta", function() {
        $(".containerFormInfoAgenzia").fadeOut("fast");
        if ($(".error").length > 0) {
            $(".error").removeClass('error')
        }
        $(".buttonRichiediApp").fadeIn("slow");
    });

    $("#caricalistato").on("click", "#Agenzie-list li", function() {
        var idAgenzia = $(this).attr("data-agenzia");
        myClick(idAgenzia, markers);
    });

    $("#formCercaAgenzia").on("click", "#geoCercaAgenzia", function() {
        $.getScript('https://maps.google.com/maps/api/js?v=3.30&libraries=places&key=' + keyApp, function() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(geoMap);
            } else {
                x.innerHTML = "Geolocation is not supported by this browser.";
            }
        });
    });

    $("#tabCitta").on("click", ".link_province", function() {
        var indirizzo = $(this).find("a").attr("title");
        if (indirizzo) {
            $("#formCercaAgenzia #indirizzo").val(indirizzo);
            $('html, body').animate({scrollTop: $("#containerMappa").offset().top-130 }, 'slow');
            var sProv = $(this).find("a").attr("data-prov");
            if (sProv) {
                indirizzo = indirizzo.toLowerCase();
                initMap(map, indirizzo, "linkProvince", sProv);
            }
        }
    });

    $("#formCercaAgenziaHome").on("click", "#geoCercaAgenzia", function() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(geoIndirizzo);
        } else {
            x.innerHTML = "Geolocation is not supported by this browser.";
        }
    });

    $("#containerAffitto").on("click", "#geolocalizzami", function() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(geoIndirizzoAffitto);
        } else {
            x.innerHTML = "Geolocation is not supported by this browser.";
        }
    });

    $("#containerMutuo").on("click", "#geolocalizzami", function() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(geoIndirizzoMutuo);
        } else {
            x.innerHTML = "Geolocation is not supported by this browser.";
        }
    });

    $("#containerMappa").on("click", ".inviaAppAgenzia", function() {
        if ($("#formRichiediAppAgenzia").valid()) {
            $(this).prop("disabled", true);
            var dati = $("#formRichiediAppAgenzia").serialize();
            $.ajax({
                url: '/richiediagenziainfo',
                type: 'POST',
                data: dati,
                success:function(data) {
                    $("#formRichiediAppAgenzia")['0'].reset();
                    $(".inviaAppAgenzia").prop("disabled",false);
                    $(".containerFormInfoAgenzia").fadeOut("fast");
                    $(".buttonRichiediApp").fadeIn("slow");
                    if (data.length > 0) {
                        $(".infoFormContAg").fadeIn("slow");
                        $(".infoFormContAg").html(data);
                        setTimeout(function() {
                            $(".infoFormContAg").fadeOut("slow");
                            $(".infoFormContAg").html("");
                        }, 3000);
                    }
                }
            });
        }
    });

    if ($("#formIlTuoMutuoSzPreoccupazioni").length > 0) {
        $("#formIlTuoMutuoSzPreoccupazioni").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error,element) {
                if (element.attr("name") == 'comune') {
                    $("#comune").parent().find("button").css({"border": "1px solid #E2001A"});
                }

            },
            rules: {
                email: {
                    required: true,
                    verifyemail:true
                },
                comune: {
                    required: true
                },
            }
        });
    }

    $("#formIlTuoMutuoSzPreoccupazioni").on("click", "#inviaIlTuoMutuoSzPreo", function() {
        if ($("#formIlTuoMutuoSzPreoccupazioni").valid()) {
            $(this).prop("disabled", true);
            var dati = $("#formIlTuoMutuoSzPreoccupazioni").serialize();
            $.ajax({
                url: '/richiedi-mutuo-sz-preoccupazioni',
                type: 'POST',
                data: dati,
                success:function(data) {
                    $("#formIlTuoMutuoSzPreoccupazioni")['0'].reset();
                    $("#inviaIlTuoMutuoSzPreo").prop("disabled",false);
                    if (data.length > 0) {
                        $("#infoForm").fadeIn("slow");
                        $("#infoForm").html(data);
                        /*setTimeout(function() {
                            $("#infoForm").fadeOut("slow");
                            $("#infoForm").html("");
                        },7000);*/
                    }
                }
            });
         }
    });

    //trovaAgenziaMutuo
    $("#formCercaAgenzia").on('click', '#cercaAgenziaMutuo', function(event) {
        event.preventDefault();
        var indirizzo = $("#indirizzo").val();
        /* Act on the event */
        $("#containerAgenzieMappa").show();
        initMap(map, indirizzo, 'mappa', '', 'cercaAgenziaMutuo');
    });

    $(".containerTuoMutuoSzPreoccupazioni").on("click", ".list li", function() {
        var idAgenzia = $(this).attr("data-agenzia")
        $("#formIlTuoMutuoSzPreoccupazioni_p1 #agenzia").val(idAgenzia);
    })

    if ($("#formIlTuoMutuoSzPreoccupazioni_p1").length > 0) {
            $("#formIlTuoMutuoSzPreoccupazioni_p1").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error,element) {
                if (element.attr("name") == 'agenzia') {
                    if ($(".errorAgenzia").length == 0) {
                        $("#containerAgenzieMappa").after('<p class="errorAgenzia">' + aLang.selezionaUnAgenziaElenco + '</p>')
                    }
                    setTimeout(function() {
                        $(".errorAgenzia").remove();
                    },6000);
                }
                return true;
            },
            rules: {
                nome: {
                    required: true
                },
                cognome: {
                    required: true
                },
                telefono: {
                    required: true,
                    numberTelefono: true
                },
                agenzia: {
                    required:true
                }
            }
        });
    }

    $("#formIlTuoMutuoSzPreoccupazioni_p1").on("click", "#inviaIlTuoMutuoSzPreo", function() {
        if ($("#formIlTuoMutuoSzPreoccupazioni_p1").valid()) {
            $("#formIlTuoMutuoSzPreoccupazioni_p1").submit();
        }
    })

    if ($("#tipo_tasso").length > 0) {
        $("#tipo_tasso").val($("#durata_mutuo option:selected").attr("data-tipo"));
    }

    $("#formIlTuoMutuoSzPreoccupazioni").on("change", "#durata_mutuo", function() {
        var dataTasso = $("#durata_mutuo option:selected").attr("data-tasso");
        var tipo_tasso = $("#durata_mutuo option:selected").attr("data-tipo");
        var sDataTasso = '';
        if (dataTasso != "" && dataTasso != undefined) {
            sDataTasso = dataTasso + "%";
        }
        $("#tipo_tasso").val(tipo_tasso);
        $("#jsTasso").html(sDataTasso);
    });

    if ($("#jsTasso").length > 0) {
        var dataTasso = $("#durata_mutuo option:selected").attr("data-tasso");
        var sDataTasso = '';
        if (dataTasso != "" && dataTasso != undefined) {
            sDataTasso = dataTasso + "%";
        }
        $("#jsTasso").html(sDataTasso);
    }

    $("#formIlTuoMutuoSzPreoccupazioni").on("keyup", "#importomutuo", function() {
        var prezzo = $(this).val();
        if (prezzo.indexOf(".") > 0) {
            prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
        prezzo = parseInt(prezzo) || 1000;
        prezzo = String(prezzo).replace(/(.)(?=(\d{3}) + $)/g,'$1.')
        $("#importomutuo").val(prezzo);
    });

    $("#formIlTuoMutuoSzPreoccupazioni").on("change", "#importomutuo", function() {
        var prezzo = $(this).val();
        if (prezzo.indexOf(".") > 0) {
            prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
        }
        if (prezzo < 1000) {
            prezzo = 1000;
        }
        prezzo = parseInt(prezzo) || 1000;
        prezzo = String(prezzo).replace(/(.)(?=(\d{3}) + $)/g,'$1.')
        $("#importomutuo").val(prezzo);
    });

    $('[data-toggle="tooltip"]').tooltip();

    if ($(".inviaRichiestaMutuo").length > 0) {
        $(".inviaRichiestaMutuo").on("change", "#mutuoImporto", function() {
            var prezzo = $(this).val();
            if (prezzo.indexOf(".") > 0) {
                prezzo = String(prezzo).replace(new RegExp(escapeRegExp("."), 'g'), "");
            }
            if (prezzo < 1000) {
                prezzo = 1000;
            }
            prezzo = parseInt(prezzo);
            prezzo = String(prezzo).replace(/(.)(?=(\d{3}) + $)/g,'$1.')
            $("#mutuoImporto").val(prezzo);
            calcoloRataMutuo(null, myDoughnutChart);
            if ($(".comparatore").length > 0) {
                calcoloRataMutuo(null, myDoughnutChartTV, 'TV');
            }
        });

        $(".inviaRichiestaMutuo").on("change", "#immobilePrezzo", function() {
            var prezzo = parseInt($(this).val().replace(/\./g, ""));

            if (isNaN(prezzo)) {
                prezzo = parseInt(prezzo) || 1250;
                $("#immobilePrezzo").val(number_format(prezzo, 0, ",", "."));
            }

            if (prezzo < parseInt(1250)) {
                prezzo = 1250;
                $("#immobilePrezzo").val(number_format(prezzo, 0, ",", "."));
            }

            var prezzoChange = prezzo / 100 * 80;
            prezzoChange = number_format(prezzoChange, 0, ",", ".");
            $("#mutuoImporto").val(prezzoChange);
            calcoloRataMutuo(null, myDoughnutChart);
            if ($(".comparatore").length > 0) {
                calcoloRataMutuo(null, myDoughnutChartTV, 'TV');
            }
        });

        function calcolaRataFissa(capitale,anniMutuo,tasso) {
            var rata;
            var tassoMensileDecimale=(tasso / 12) / 100;
            rata = (capitale * tassoMensileDecimale) / (1 - (1 / (Math.pow(1 + tassoMensileDecimale, anniMutuo * 12))));
            return rata
        }

        function calcoloRataMutuo(init, chart, tipoTasso = 'TF') {
            nValore = $("#immobilePrezzo").val().replace(/\./g, "");
            nValore = parseInt(nValore);
            nCapitale = $("#mutuoImporto").val().replace(/\./g, "");
            nCapitale = parseInt(nCapitale);
            nCadenza = 12;
            nAnniMutuo = $("#mutuoDurata").val();
            if (tipoTasso == 'TF') {
                nTasso = $("#mutuoDurata option:selected").attr("rel");
            } else {
                nTasso = $("#mutuoDurata option:selected").attr("data-tv");
            }
            nLimitMutuo = nValore / 100 * 100;

            if (nCapitale > nLimitMutuo) {
                nCapitale = nLimitMutuo;
            }

            if ($(".comparatore").length > 0) {
                nTassoTF = $("#mutuoDurata option:selected").attr("rel");
                $("#tassoChange").html("Fisso: " + nTassoTF + "% - Variabile: " + nTasso.replace(".", ",") + "%");
            } else {
                $("#tassoChange").html(nTasso.replace(".", ",") + "%");
            }

            // if ($(".comparatore").length > 0) {
            //  nTassoTF = $("#mutuoDurata option:selected").attr("rel");
            //  $("#tassoChange1").html("" + nTassoTF + "%");
            //  $("#tassoChange2").html("" + nTasso.replace(".", ",") + "%");
            // } else {
            //  $("#tassoChange").html(nTasso.replace(".", ",") + "%");
            // }

            if (parseInt(nCapitale) <= parseInt(nValore)) {
                $("#mutuoRata").html(0);

                nMesiMutuo = nAnniMutuo * nCadenza;
                nTassoMese = nTasso / (100 * nCadenza);
                nTarroCalcolo = nTassoMese + 1;
                nMesiCalcolo = nMesiMutuo - 1;
                nSomma = 0;

                for (i = 0; i < nMesiCalcolo; i++) {
                    nPow = Math.pow(nTarroCalcolo, i);
                    nSomma += nPow;
                }

                nPot = Math.pow(nTarroCalcolo, nMesiMutuo);
                nRata = calcolaRataFissa(nCapitale, nAnniMutuo, parseFloat(nTasso));
                nTassoot = nRata * nMesiMutuo;
                nInteressi = nTassoot - nCapitale;
                nMutuoPerc = parseInt(nCapitale / nValore * 100);
                nMutuoPercAnticipo = 100 - nMutuoPerc;

                if (nRata < 1) {
                    nRata = 0;
                }
                if (nRata > 1) {
                    nRata = number_format(nRata, 0, ",", ".");
                }

                $("#mutuoRata" + tipoTasso).html(nRata);
                $("#mutuoPercAnticipo" + tipoTasso).html(nMutuoPercAnticipo);
                $("#mutuoPerc" + tipoTasso).html(parseInt(nMutuoPerc));
            }

            $("#mutuoImporto").val(number_format(nCapitale, 0, ",", "."));
            $("#immobilePrezzo").val(number_format(nValore, 0, ",", "."));

            // Passaggio valori chart mutuo
            if (init === null) {
                chart.data.datasets[0].data[0] = nMutuoPerc;
                chart.data.datasets[0].data[1] = nMutuoPercAnticipo;
                chart.update();
            }

            aggiornaHrefMutuo();
        }

        function aggiornaHrefMutuo() {
            if ($('input#mutuoImporto').length) {
                mutuoImporto = parseInt($("input#mutuoImporto").val().replace(".", ""));
                mutuoDurata = $("#mutuoDurata").val();
                hrefRichiestaMutuo = $("#richiesta-mutuo").attr("href").split("?")[0];
                $('#richiesta-mutuo').attr("href", hrefRichiestaMutuo + "?importo_mutuo=" + mutuoImporto + "&durata_mutuo=" + mutuoDurata + "&tipo_tasso=TF");
                if ($(".comparatore").length) {
                    $('#richiesta-mutuoTV').attr("href", hrefRichiestaMutuo + "?importo_mutuo=" + mutuoImporto + "&durata_mutuo=" + mutuoDurata + "&tipo_tasso=TV");
                }
            }
        }

        // --------------------------------------------------------------------
        // Gestione del calcolo di rata del mutuo
        if ($(".calcoloMutuo").length !== 0) {
            calcoloRataMutuo(1, null);
            if ($(".comparatore").length > 0) {
                calcoloRataMutuo(1,null, 'TV');
            }

            $("#immobilePrezzo").keyup(function () {
                calcoloRataMutuo(null, myDoughnutChart);
                if ($(".comparatore").length > 0) {
                    calcoloRataMutuo(null, myDoughnutChartTV, 'TV');
                }
            });

            $(".calcoloMutuoValue").keyup(function () {
                calcoloRataMutuo(null, myDoughnutChart);
                if ($(".comparatore").length > 0) {
                    calcoloRataMutuo(null, myDoughnutChartTV, 'TV');
                }
            });

            $(".calcoloMutuoValue").change(function () {
                calcoloRataMutuo(null, myDoughnutChart);
                if ($(".comparatore").length > 0) {
                    calcoloRataMutuo(null, myDoughnutChartTV, 'TV');
                }
            });

            $(".inviaRichiestaMutuo #mutuoDurata").change(function () {
                myDoughnutChart = new Chart(ctx, {
                    type: "doughnut",
                    data: {
                        labels: [
                            $("#mutuoLabelTF").html(),
                            $("#anticipoLabelTF").html()
                        ],
                        datasets: [{
                            data: [
                                0,
                                100
                            ],
                            backgroundColor: [
                                "#001741",
                                "#1061a6"
                            ],
                            label: "My dataset" // for legend
                        }]
                    },
                    options: {
                        cutoutPercentage: 70
                    },
                    legend: {
                        display: false
                    }
                });

                if ($(".comparatore").length > 0) {
                    myDoughnutChartTV = new Chart($("#mutuoChartTV"), {
                        type: "doughnut",
                        data: {
                            labels: [
                                $("#mutuoLabelTV").html(),
                                $("#anticipoLabelTV").html()
                            ],
                            datasets: [{
                                data: [
                                    0,
                                    100
                                ],
                                backgroundColor: [
                                    "#001741",
                                    "#1061a6"
                                ],
                                label: "My dataset" // for legend
                            }]
                        },
                        options: {
                            cutoutPercentage: 70
                        },
                        legend: {
                            display: false
                        }
                    });
                }

                calcoloRataMutuo(null, myDoughnutChart);
                if ($(".comparatore").length > 0) {
                    calcoloRataMutuo(null, myDoughnutChartTV, 'TV');
                }
            });

            // Gestione chart Mutuo
            Chart.defaults.global.legend.display = false;

            ctx = $("#mutuoChart");
            var myDoughnutChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                    labels: [
                        $("#mutuoLabelTF").html(),
                        $("#anticipoLabelTF").html()
                    ],
                    datasets: [{
                            data: [
                                nMutuoPerc,
                                nMutuoPercAnticipo
                            ],
                            backgroundColor: [
                                "#001741",
                                "#1061a6"
                            ],
                            label: "My dataset" // for legend
                        }]
                },
                options: {
                    cutoutPercentage: 70
                },
                legend: {
                    display: false
                }
            });

            var myDoughnutChartTV = new Chart($("#mutuoChartTV"), {
                type: "doughnut",
                data: {
                    labels: [
                        $("#mutuoLabelTV").html(),
                        $("#anticipoLabelTV").html()
                    ],
                    datasets: [{
                        data: [
                            nMutuoPerc,
                            nMutuoPercAnticipo
                        ],
                        backgroundColor: [
                            "#001741",
                            "#1061a6"
                        ],
                        label: "My dataset" // for legend
                    }]
                },
                options: {
                    cutoutPercentage: 70
                },
                legend: {
                    display: false
                }
            });
        }
    }

    if ($("#formContattiLavoraConNoi").length > 0) {
        validateFormLavoraConNoi("#formContattiLavoraConNoi");
    }

    $('#formContattiLavoraConNoi').on("click", "#inviaFormContatti", function () {
        if ($("#formContattiLavoraConNoi").valid()) {
            $(this).prop("disabled", true);
            var formData = new FormData($('#formContattiLavoraConNoi')[0]);

            if ($("#caricaCV").val() != undefined) {
                formData.append('caricaCV', $("input[type=file][id='caricaCV']")[0].files[0]);
            }

            $.ajax({
                type: "POST",
                url: "/inviacurriculum",
                data: formData,
                cache: false,
                mimeType: "multipart/form-data",
                contentType: false,
                processData: false,
                success: function (data) {
                    if (data == "OK") {
                        location.href = $("#inviaForm").attr("data-conferma");
                    }
                }
            });
        }
    });

    if ($("#cookie").length) {
        cookieControl = 0;
        $(".accept-cookie").click(function () {
            if (cookieControl == 0) {
                $.get("/setCookie");
                $("#cookie").hide();
            }
            cookieControl = 1;
        });
    }

    if ($('#formMutuoPerfetto').length > 0) {
        $("#formMutuoPerfetto").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error,element) {
                if (element.attr("name") == 'comune') {
                    $("#comune").parent().find("button").css({"border": "1px solid #E2001A"});
                }
            },
            rules: {
                email: {
                    required: true,
                    verifyemail: true
                },
                importo_immobile: {
                    digits: true,
                },
                reddito_mensile: {
                    digits: true,
                },
                anticipo: {
                    digits: true,
                },
                comune: {
                    required: true
                }
            }
        });

        $('#formMutuoPerfetto').on('click', '#inviaMutuoPerfetto', function () {
            var btn = $(this);
            var form = $('#formMutuoPerfetto');
            var action = form.attr('action');
            var data = form.serialize();

            btn.prop("disabled", true);

            if ($(form).valid()) {
                $.ajax({
                    url: action,
                    type: 'POST',
                    data: data,
                })
                .done(function(data) {
                    $(form)[0].reset();
                    $('#inviaMutuoPerfetto').prop("disabled", false);
                    if (data.length > 0) {
                        $("#infoForm").html(data);
                        $("#infoForm").fadeIn("slow");
                    }
                })
                .fail(function() {
                    console.log("error");
                })
                .always(function() {
                    btn.prop("disabled", false);
                });
            } else {
                btn.prop("disabled", false);
            }
        });
    }

    if ($('#formCambiaMutuo').length > 0) {
        $("#formCambiaMutuo").validate({
            ignore: [],
            focusInvalid: false,
            errorPlacement: function(error,element) {
                if (element.attr("name") == 'comune') {
                    $("#comune").parent().find("button").css({"border": "1px solid #E2001A"});
                }
            },
            rules: {
                email: {
                    required: true,
                    verifyemail: true
                },
                anni_rimanenti: {
                    digits: true,
                },
                costo_mensile: {
                    digits: true,
                },
                residuo: {
                    digits: true,
                },
                comune: {
                    required: true
                }
            }
        });

        $('#formCambiaMutuo').on('click', '#inviaCambiaMutuo', function () {
            var btn = $(this);
            var form = $('#formCambiaMutuo');
            var action = form.attr('action');
            var data = form.serialize();

            btn.prop("disabled", true);
            if ($(form).valid()) {
                $.ajax({
                    url: action,
                    type: 'POST',
                    data: data,
                })
                .done(function(data) {
                    $(form)[0].reset();
                    $('#inviaCambiaMutuo').prop("disabled", false);
                    if (data.length > 0) {
                        $("#infoForm").html(data);
                        $("#infoForm").fadeIn("slow");
                    }
                })
                .fail(function() {
                    console.log("error");
                })
                .always(function() {
                    btn.prop("disabled", false);
                });
            } else {
                btn.prop("disabled", false);
            }
        });
    }

    $('#comune').change(function() {
        if ($(this).val() != '') {
            $("#comune").parent().find("button").css({"border": "1px solid #ccc"});
        } else {
            $("#comune").parent().find("button").css({"border": "1px solid #E2001A"});
        }
    });

    $(document).on('change', '#immobile-Prezzo', function() {
        const maxValue = parseInt($(this).attr('max'));

        if ($(this).val() > maxValue) {
            $(this).val(maxValue);
        }

        const percentage = $(this).val() / maxValue * 100;
        $('#slider-immobile-prezzo .ui-slider-range').css('width', (100 - percentage) + '%');
        $('#slider-immobile-prezzo .ui-slider-handle').css('left', percentage + '%');
    });

    $(document).on('change', '#affitto-prezzo', function() {
        const maxValue = parseInt($(this).attr('max'));

        if ($(this).val() > maxValue) {
            $(this).val(maxValue);
        }

        const percentage = $(this).val() / maxValue * 100;
        $('#slider-affitto-prezzo .ui-slider-range').css('width', (100 - percentage) + '%');
        $('#slider-affitto-prezzo .ui-slider-handle').css('left', percentage + '%');
    });
});

function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };

    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3}) +(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }

    return s.join(dec);
}

function clickButtonCercaAgenzia(map) {
    var indirizzo = $("#indirizzo").val();
    if (indirizzo.length < 4) {
        $("#errorMessagge").html("Indirizzo deve essere maggiore di 3 caratteri!");
        $("#cercaAgenzia").attr("disabled", false);
        return false;
    } else {
        $("#errorMessagge").html("");
    }
    initMap(map, indirizzo);
    return false;
}

function geoLocation(form,campo,latitude,longitude) {
    var geocoderIndirizzo = new google.maps.Geocoder();
    var latlng = {lat: parseFloat(latitude), lng: parseFloat(longitude)};
    geocoderIndirizzo.geocode({'location': latlng}, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            $("#" + form + " #" + campo).val(results[0].formatted_address);
        }
    });
}

function geoMap(position) {
    geoLocation("formCercaAgenzia", "indirizzo", position.coords.latitude, position.coords.longitude);
    var indirizzo = parseFloat(position.coords.latitude) + ", " + parseFloat(position.coords.longitude);
    initMap(map, indirizzo);
}

function geoIndirizzo(position) {
    geoLocation("formCercaAgenziaHome", "indirizzo", position.coords.latitude, position.coords.longitude);
}

function geoIndirizzoAffitto(position) {
    geoLocation("containerAffitto", "indirizzo", position.coords.latitude, position.coords.longitude);
    $('#lat').val(position.coords.latitude)
    $('#long').val(position.coords.longitude)
    updateAffittoHref()
}

function geoIndirizzoMutuo(position) {
    geoLocation("containerMutuo", "indirizzo", position.coords.latitude, position.coords.longitude);
    $('#lat').val(position.coords.latitude)
    $('#long').val(position.coords.longitude)
    updateMutuoHref()
}

function validatorExt(idForm) {
    jQuery.validator.addMethod("isMailOrTel", function (value, element) {
        var email = $(idForm + " input[name=email]").val().trim();
        var tel = '';

        if ($(idForm + " input[name=telefono]").length > 0) {
            tel = $(idForm + " input[name=telefono]").val();
        }

        var aConf = [];

        if (tel != '' && tel != undefined && email != '' && email != undefined) {
            var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:[a-zA-Z0-9](?:\.[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]{2,6}))$/i;
            if (email.match(regex)) {
                aConf.push(1);
            } else {
                aConf.push(0);
            }
        } else if (tel != '' && tel != undefined) {
            aConf.push(1);
        } else if (email != '' && email != undefined) {
            var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:[a-zA-Z0-9](?:\.[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]{2,6}))$/i;
            if (email.match(regex)) {
                aConf.push(1);
            } else {
                aConf.push(3);
            }
        } else {
            aConf.push(0);
        }

        if ($.inArray(1, aConf) != -1) {
            return true;
        } else {
            return false;
        }
    }, "Inserire una email o telefono.");

    jQuery.validator.addMethod("isNomeOCognome", function (value, element) {
        var nome = $(idForm + " #fc_nome").val();
        var cognome = $(idForm + " #fc_cognome").val();
        var aConf = [];

        if (nome != '' && nome != undefined) {
            aConf.push(1);
        } else {
            aConf.push(0);
        }

        if (cognome != '' && cognome != undefined) {
            aConf.push(1);
        } else {
            aConf.push(0);
        }

        if ($.inArray(1, aConf) != -1) {
            return true;
        } else {
            return false;
        }
    }, "Inserire un nome o cognome.");

    $.validator.addMethod('contieneLettereENumeri', function(value, element) {
        return this.optional(element) || (value.match(/[a-zA-Z]/) && value.match(/[0-9]/));
    }, aLang.validaLettereENumeri);
}

function validateFormLavoraConNoi(idForm) {
    validatorExt(idForm);

    $(idForm).validate({
        ignore: [],
        focusInvalid: false,
        errorPlacement: function (error, element) {
            if (element.attr("name")) {
                if (element.attr("name") == "email")
                    error.insertAfter('#email');
                if (element.attr("name") == 'motivazione') {
                    $("input[name=" + element.attr("name") + "]").parent().parent().attr("style", "color:red");
                } else if (element.attr("name") == 'tipologia') {
                    $("label[for=" + element.attr("id") + "]").attr("style", "color:red");
                    $("select[name=" + element.attr("name") + "]").parent().find("button").attr("style", "border: 1px solid red;");
                } else if (element.attr("name") == 'provinciaLav') {
                    $("select[name=" + element.attr("name") + "]").parent().find("button").attr("style", "border: 1px solid red;");
                } else {
                    $("label[for=" + element.attr("id") + "]").attr("style", "color:red");
                }
            }
            return true;
        },
        rules: {
            nome: {
                isNomeOCognome: true
            },
            cognome: {
                isNomeOCognome: true
            },
            email: {
                isMailOrTel: true
            },
            telefono: {
                isMailOrTel: true,
                numberTelefono:true
            },
            caricaCV: {
                required: true
            },
            tipologia: {
                required: true
            },
            motivazione: {
                required: true,
            },
            provinciaLav: {
                required: true,
            },
            privacy_imm: {
                required: true,
            }
        },
        messages: {
            email: {
                verifyemail: "Email inserita non valida!"
            }
        }
    });

    $(idForm).on("focusout", ".bootstrap-select", function () {
        if ($(this).parent().find("button").attr("style") == 'border: 1px solid red;') {
            if ($(this).find("select").valid()) {
                $(this).parent().find("button").css("border", "1px solid #ccc");
                $(this).parent().find("button").parent().parent().parent().find("label").css("color", "#5a5a5c");
            }
        }
    });

    $(idForm).on("change", "input", function () {
        var nome = $(this).attr("id");
        if (nome == 'fc_nome' || nome == 'fc_cognome') {
            if ($(this).valid()) {
                $("#fc_nome").removeClass("error");
                $("#fc_cognome").removeClass("error");
            }
        } else if (nome == 'fc_telefono' || nome == 'fc_email') {
            if ($(this).valid()) {
                $("#fc_telefono").removeClass("error");
                $("#fc_email").removeClass("error");
            }
        }
        if (nome == 'labelfc_motivazioneVendita' || nome == 'labelfc_motivazioneAffitto') {
            if ($(this).valid()) {
                $(this).parent().parent().removeAttr("style");
            } else {
                $(this).parent().parent().attr("style", "color:red");
            }
        } else if ($("label[for=" + nome + "]").attr("style") == 'color:red') {
            if ($(this).valid()) {
                $(this).css("border", "1px solid #ccc");
                $(this).parent().parent().find("label").css("color", "#5a5a5c");

                if ($(idForm + ' #email-error').length > 0) {
                    $(idForm + ' #email-error').remove();
                }
            } else {
                $(this).css("border", "2px solid red");
                $(this).parent().parent().find("label").css("color", "red");
            }
        }
    });
}

function myMarkerOver(id, markers) {
    var urlMarker = "/img/trovagenzia/marker.png";
    var urlMarkerOver = "/img/trovagenzia/markerOver.png";

    $.each($("#Agenzie-list .list li"), function () {
        if ($(this).attr("data-click") != 1) {
            $(this).removeAttr("style");
        }
    });

    $("#containerAgenzieMappa").find("#Agenzie-list li[data-agenzia=" + id + "]").attr("style", "background:#f3f3f3");

    var marIcon = new google.maps.MarkerImage(
        urlMarker,
        null, /* size is determined at runtime */
        null, /* origin is 0,0 */
        null, /* anchor is bottom center of the scaled image */
        new google.maps.Size(30, 35)
    );

    var marIcon2 = new google.maps.MarkerImage(
        urlMarkerOver,
        null, /* size is determined at runtime */
        null, /* origin is 0,0 */
        null, /* anchor is bottom center of the scaled image */
        new google.maps.Size(30, 35)
    );

    var marIconEpi = new google.maps.MarkerImage(
        '/img/trovagenzia/markerEpica.png',
        null, /* size is determined at runtime */
        null, /* origin is 0,0 */
        null, /* anchor is bottom center of the scaled image */
        new google.maps.Size(30, 35)
    );

    var marIconEpiOver = new google.maps.MarkerImage(
        '/img/trovagenzia/markerEpicaOver.png',
        null, /* size is determined at runtime */
        null, /* origin is 0,0 */
        null, /* anchor is bottom center of the scaled image */
        new google.maps.Size(30, 35)
    );

    $.each($("#Agenzie-list .list li"), function () {
        if (markers[$(this).attr("data-agenzia")] != undefined) {
            if (markers[$(this).attr("data-agenzia")].rete == 'epi') {
                markers[$(this).attr("data-agenzia")].setIcon(marIconEpi);
            } else {
                 markers[$(this).attr("data-agenzia")].setIcon(marIcon);
            }
        }
    });

    if (isMobile == false) {
        if (markers[id].rete == 'epi') {
            markers[id].setIcon(marIconEpiOver);
        } else {
             markers[id].setIcon(marIcon2);
        }
    }
}

function myClick(id) {
    $("#Agenzie-list li").removeAttr('style');
    $("#containerAgenzieMappa").find("#Agenzie-list li[data-agenzia=" + id + "]").attr("style", "background:#f3f3f3");
    google.maps.event.trigger(markers[id], 'click');
}

function makeMarker(position, icon, title) {
    startMarker = new google.maps.Marker({
        position: position,
        map: map,
        icon: icon,
        title: title
    });
}